import { render, staticRenderFns } from "./showEditionOrganizers.vue?vue&type=template&id=4e0faa04"
import script from "./showEditionOrganizers.vue?vue&type=script&lang=js"
export * from "./showEditionOrganizers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports